const messages = {
  en: {
    connectWallet: 'Connect Wallet',
    switchWallet: 'Connected',
    disconnected: 'Disconnected',
    installWallet: 'Please install MetaMask or another Web3 wallet',
    connectFirst: 'Please connect your wallet first',
    tabHome: 'Dashboard',
    tabInvest: 'Invest',
    tabWithdraw: 'Withdraw',
    tabTeam: 'Team',
    walletBalance: 'Wallet Balance',
    healthy: 'Healthy',
    ocPrice: 'OC Real-time Price',
    sellTax: 'Current Sell Tax',
    onChainSource: 'On-chain Price',
    srtDynamic: 'SRT Dynamic',
    todayYield: 'Today Yield',
    yieldDesc: 'Determined by OC/ALK pool',
    bonusPool: 'Bonus Pool Balance',
    bonusAmount: '231M OC',
    bonusDesc: 'Auto-replenish below threshold',
    enterAmount: 'Enter Investment Amount',
    min: 'Min',
    max: 'Max',
    investDesc: 'Auto-split by amount: 50% buy OC, 50% combine OC/ALK LP lock.',
    confirmInvest: 'Confirm Investment',
    myOrders: 'My Orders',
    order: 'Order',
    principal: 'Principal',
    dailyYield: 'Daily Yield',
    fullReinvest: 'Full Reinvest',
    redeemExit: 'Redeem & Exit',
    running: 'Running',
    expired: 'Expired',
    daysLeft: ' days left',
    expiredProcess: 'Expired, process now',
    availableBalance: 'Withdrawable Balance',
    notice: 'Actual receipt = amount - 3% fee. Subject to final confirmation.',
    confirmInfo: 'Withdrawal Confirmation Info',
    applyAmount: 'Apply Amount',
    receiveRatio: 'Receive Ratio',
    estimatedReceipt: 'Est. Receipt',
    equivalentOC: 'USDT equiv. OC',
    forceReinvest: 'Force Reinvest',
    profitTax: 'Profit Tax',
    fee: 'Fee',
    receiveAmount: 'Receipt Amount',
    reinvest100: 'Reinvest 100U',
    reinvest100Hint: '100 USDT equivalent OC will be deducted from balance to create a 30-day reinvest order.',
    confirm: 'Confirm',
    confirmWithdraw: 'Confirm Withdraw',
    withdrawSuccess: 'Withdrawal submitted',
    reinvestSuccess: 'Reinvest submitted',
    referralLink: 'Referral Link',
    copyLink: 'Copy Link',
    directCount: 'Direct Referrals',
    teamCount: 'Team Size',
    gen1: '1st Gen',
    gen1to15: '1-15 Gen',
    currentLevel: 'Current Level',
    levelBonus: 'Diff Bonus',
    majorZone: 'Major Zone',
    minorZone: 'Minor Zone',
    largestBranch: 'Largest Branch',
    otherBranches: 'Other Branches',
    teamStructure: 'Team Structure',
    teamDept: 'Dept',
    major: 'Major',
    minor: 'Minor',
    rewardsOverview: 'Rewards Overview',
    orderReward: 'Order Yield',
    levelDiffReward: 'Level Diff Bonus',
    managementReward: 'Management Reward',
    todayReward: 'Today',
    today: 'Today',
    linkCopied: 'Invite link copied',
    bindRefTitle: 'Bind Referral',
    bindRefPlaceholder: 'Enter referral code',
    bindRefConfirm: 'Confirm',
    bindRefSkip: 'Skip',
    bindRefSuccess: 'Referral bound successfully',
    bindRefFailed: 'Bind failed, please try again',
    bindRefSelf: 'Cannot use your own address as referral',
    cycleCountdown: '30-Day Cycle Countdown',
    genesisnode: 'Genesis Node',
    genesisnodeEarnings: 'Genesis Node Earnings',
    distance: 'Distance to',
    stillNeed: 'still need',
    minorPerformance: 'minor zone performance',
    reached: 'Already reached',
    levelMax: 'Max level reached',
    cancel: 'Cancel',
    confirmRedeem: 'Confirm Redemption',
    genesisWithdrawHint: 'This will withdraw all available earnings to your wallet.',
    insufficientBalance: 'Insufficient balance',
    balanceDetail: 'Transaction History',
    noRecords: 'No records',
    loadMore: 'Load More',
    typeOrderIncome: 'Order Income',
    typeReward: 'Rank Reward',
    typeGenerationReward: 'Referral Reward',
    typeWithdraw: 'Withdrawal',
    typeWithdrawRefund: 'Withdrawal Refund',
    typeReinvest: 'Reinvest',
    typeRedeem: 'Redemption',
  },
  zh: {
    connectWallet: '連接錢包',
    switchWallet: '已連接',
    disconnected: '未連接',
    installWallet: '請安裝MetaMask或其他Web3錢包',
    connectFirst: '請先連接錢包',
    tabHome: '首頁看板',
    tabInvest: '投資訂單',
    tabWithdraw: '提現流程',
    tabTeam: '團隊邀請',
    walletBalance: '錢包餘額',
    healthy: '健康',
    ocPrice: 'OC 即時價格',
    sellTax: '當前賣出稅率',
    onChainSource: '鏈上價格源',
    srtDynamic: 'SRT 動態調整',
    todayYield: '今日收益率',
    yieldDesc: '由 OC/ALK 池規模決定',
    bonusPool: '獎金庫餘額',
    bonusAmount: '2.31億 OC',
    bonusDesc: '低於閾值自動補倉',
    enterAmount: '請輸入投入金額',
    min: '最低',
    max: '最高',
    investDesc: '後台按投入金額自動拆分：50%買OC，50%組合OC/ALK LP鎖定。',
    confirmInvest: '確認投入',
    myOrders: '我的訂單',
    order: '訂單',
    principal: '本金',
    dailyYield: '日收益',
    fullReinvest: '全額複投',
    redeemExit: '贖回離場',
    running: '運行中',
    expired: '已到期',
    daysLeft: '天剩餘',
    expiredProcess: '已到期，可處理',
    availableBalance: '可提現餘額',
    notice: '實際到賬 = 申請金額 - 3% 手續費，最終以確認為準。',
    confirmInfo: '提現確認頁資訊',
    applyAmount: '申請金額',
    receiveRatio: '當前到賬比例',
    estimatedReceipt: '預計到賬',
    equivalentOC: 'USDT 等值 OC',
    forceReinvest: '強制複投',
    profitTax: '盈利稅',
    fee: '手續費',
    receiveAmount: '到賬金額',
    reinvest100: '複投 100U',
    reinvest100Hint: '將從餘額扣除 100 USDT 等值 OC，創建 30 天複投訂單。',
    confirm: '確認',
    confirmWithdraw: '確認提現',
    withdrawSuccess: '提現已提交',
    reinvestSuccess: '複投已提交',
    referralLink: '推薦鏈接',
    copyLink: '複製鏈接',
    directCount: '直推人數',
    teamCount: '團隊人數',
    gen1: '1代',
    gen1to15: '1-15代',
    currentLevel: '當前等級',
    levelBonus: '級差獎',
    majorZone: '大區業績',
    minorZone: '小區業績',
    largestBranch: '最大分支',
    otherBranches: '其他分支合計',
    teamStructure: '團隊結構示意',
    teamDept: '部門',
    major: '大區',
    minor: '小區',
    rewardsOverview: '獎勵概覽',
    orderReward: '訂單收益',
    levelDiffReward: '級差獎',
    managementReward: '管理獎',
    todayReward: '今日',
    today: '今日',
    linkCopied: '邀請鏈接已複製',
    bindRefTitle: '綁定推薦人',
    bindRefPlaceholder: '請輸入推薦碼',
    bindRefConfirm: '確認綁定',
    bindRefSkip: '跳過',
    bindRefSuccess: '推薦人綁定成功',
    bindRefFailed: '綁定失敗，請重試',
    bindRefSelf: '不能使用自己的地址作為推薦人',
    cycleCountdown: '30 天週期倒計時',
    genesisnode: '創世節點',
    genesisnodeEarnings: '創世節點收益',
    distance: '距離',
    stillNeed: '還需',
    minorPerformance: '小區業績',
    reached: '已達到',
    levelMax: '已達最高等級',
    cancel: '取消',
    confirmRedeem: '確認贖回',
    genesisWithdrawHint: '將提取所有可用收益到您的錢包。',
    insufficientBalance: '餘額不足',
    balanceDetail: '流水記錄',
    noRecords: '暫無記錄',
    loadMore: '加載更多',
    typeOrderIncome: '訂單收入',
    typeReward: '等級獎',
    typeGenerationReward: '推薦獎',
    typeWithdraw: '提現',
    typeWithdrawRefund: '提現退還',
    typeReinvest: '複投',
    typeRedeem: '贖回',
  },
  ko: {
    connectWallet: '지갑 연결',
    switchWallet: '연결됨',
    disconnected: '연결 끊김',
    installWallet: 'MetaMask 또는 다른 Web3 지갑을 설치하세요',
    connectFirst: '먼저 지갑을 연결하세요',
    tabHome: '대시보드',
    tabInvest: '투자',
    tabWithdraw: '출금',
    tabTeam: '팀',
    walletBalance: '지갑 잔액',
    healthy: '정상',
    ocPrice: 'OC 실시간 가격',
    sellTax: '현재 매도 세율',
    onChainSource: '온체인 가격',
    srtDynamic: 'SRT 동적 조정',
    todayYield: '오늘 수익률',
    yieldDesc: 'OC/ALK 풀 규모로 결정',
    bonusPool: '보너스 풀 잔액',
    bonusAmount: '2.31억 OC',
    bonusDesc: '임계값 미만 시 자동 충전',
    enterAmount: '투자 금액 입력',
    min: '최소',
    max: '최대',
    investDesc: '금액에 따라 자동 분할: 50%는 OC 구매, 50%는 OC/ALK LP 구성 후 잠금.',
    confirmInvest: '투자 확인',
    myOrders: '내 주문',
    order: '주문',
    principal: '원금',
    dailyYield: '일일 수익',
    fullReinvest: '전액 재투자',
    redeemExit: '상환 및 종료',
    running: '진행 중',
    expired: '만료됨',
    daysLeft: '일 남음',
    expiredProcess: '만료됨, 지금 처리',
    availableBalance: '출금 가능 잔액',
    notice: '실제 수령액 = 금액 - 3% 수수료. 최종 확인을 기준으로 합니다.',
    confirmInfo: '출금 확인 정보',
    applyAmount: '신청 금액',
    receiveRatio: '현재 수령 비율',
    estimatedReceipt: '예상 수령액',
    equivalentOC: 'USDT 등가 OC',
    forceReinvest: '강제 재투자',
    profitTax: '수익세',
    fee: '수수료',
    receiveAmount: '수령 금액',
    reinvest100: '재투자 100U',
    reinvest100Hint: '잔액에서 100 USDT 등가 OC를 차감하여 30일 재투자 주문을 생성합니다.',
    confirm: '확인',
    confirmWithdraw: '출금 확인',
    withdrawSuccess: '출금이 제출되었습니다',
    reinvestSuccess: '재투자가 제출되었습니다',
    referralLink: '추천 링크',
    copyLink: '링크 복사',
    directCount: '직추천 수',
    teamCount: '팀원 수',
    gen1: '1대',
    gen1to15: '1-15대',
    currentLevel: '현재 등급',
    levelBonus: '등급 차 보너스',
    majorZone: '메이저존 실적',
    minorZone: '마이너존 실적',
    largestBranch: '최대 브랜치',
    otherBranches: '기타 브랜치 합계',
    teamStructure: '팀 구조',
    teamDept: '부서',
    major: '메이저',
    minor: '마이너',
    rewardsOverview: '보상 개요',
    orderReward: '주문 수익',
    levelDiffReward: '등급 차 보너스',
    managementReward: '관리 보상',
    todayReward: '오늘',
    today: '오늘',
    linkCopied: '초대 링크가 복사되었습니다',
    bindRefTitle: '추천인 등록',
    bindRefPlaceholder: '추천 코드 입력',
    bindRefConfirm: '등록 확인',
    bindRefSkip: '건너뛰기',
    bindRefSuccess: '추천인 등록 성공',
    bindRefFailed: '등록 실패, 다시 시도하세요',
    bindRefSelf: '자신의 주소는 추천인으로 사용할 수 없습니다',
    cycleCountdown: '30일 주기 카운트다운',
    genesisnode: '제네시스 노드',
    genesisnodeEarnings: '제네시스 노드 수익',
    distance: '거리',
    stillNeed: '필요',
    minorPerformance: '마이너존 실적',
    reached: '달성 완료',
    levelMax: '최고 등급 달성',
    cancel: '취소',
    confirmRedeem: '상환 확인',
    genesisWithdrawHint: '사용 가능한 모든 수익을 지갑으로 출금합니다.',
    insufficientBalance: '잔액 부족',
    balanceDetail: '거래 내역',
    noRecords: '기록 없음',
    loadMore: '더 보기',
    typeOrderIncome: '주문 수입',
    typeReward: '등급 보상',
    typeGenerationReward: '추천 보상',
    typeWithdraw: '출금',
    typeWithdrawRefund: '출금 환불',
    typeReinvest: '재투자',
    typeRedeem: '상환',
  },
  ja: {
    connectWallet: 'ウォレット接続',
    switchWallet: '接続済み',
    disconnected: '未接続',
    installWallet: 'MetaMaskまたは他のWeb3ウォレットをインストールしてください',
    connectFirst: '先にウォレットを接続してください',
    tabHome: 'ダッシュボード',
    tabInvest: '投資',
    tabWithdraw: '出金',
    tabTeam: 'チーム',
    walletBalance: 'ウォレット残高',
    healthy: '正常',
    ocPrice: 'OC リアルタイム価格',
    sellTax: '現在の売却税率',
    onChainSource: 'オンチェーン価格',
    srtDynamic: 'SRT 動的調整',
    todayYield: '本日収益率',
    yieldDesc: 'OC/ALKプール規模により決定',
    bonusPool: 'ボーナスプール残高',
    bonusAmount: '2.31億 OC',
    bonusDesc: '閾値を下回ると自動補充',
    enterAmount: '投資額を入力',
    min: '最小',
    max: '最大',
    investDesc: '金額に応じて自動分割：50%でOC購入、50%でOC/ALK LP組み立てロック。',
    confirmInvest: '投資確認',
    myOrders: 'マイオーダー',
    order: 'オーダー',
    principal: '元本',
    dailyYield: '日次収益',
    fullReinvest: '全額再投資',
    redeemExit: '償還・退出',
    running: '運用中',
    expired: '満了',
    daysLeft: '日残り',
    expiredProcess: '満了、今すぐ処理',
    availableBalance: '出金可能残高',
    notice: '実際の受取額 = 金額 - 3% 手数料。最終確認を優先してください。',
    confirmInfo: '出金確認情報',
    applyAmount: '申請金額',
    receiveRatio: '現在の受取比率',
    estimatedReceipt: '予定受取額',
    equivalentOC: 'USDT換算OC',
    forceReinvest: '強制再投資',
    profitTax: '利益税',
    fee: '手数料',
    receiveAmount: '受取額',
    reinvest100: '再投資 100U',
    reinvest100Hint: '残高から 100 USDT 相当の OC を差し引き、30日間の再投資オーダーを作成します。',
    confirm: '確認',
    confirmWithdraw: '出金確認',
    withdrawSuccess: '出金が提出されました',
    reinvestSuccess: '再投資が提出されました',
    referralLink: '紹介リンク',
    copyLink: 'リンクをコピー',
    directCount: '直接紹介数',
    teamCount: 'チーム人数',
    gen1: '1世代',
    gen1to15: '1-15世代',
    currentLevel: '現在のレベル',
    levelBonus: 'レベル差ボーナス',
    majorZone: 'メジャーゾーン業績',
    minorZone: 'マイナーゾーン業績',
    largestBranch: '最大ブランチ',
    otherBranches: 'その他ブランチ合計',
    teamStructure: 'チーム構成',
    teamDept: '部門',
    major: 'メジャー',
    minor: 'マイナー',
    rewardsOverview: '報酬概要',
    orderReward: 'オーダー収益',
    levelDiffReward: 'レベル差ボーナス',
    managementReward: '管理報酬',
    todayReward: '本日',
    today: '本日',
    linkCopied: '招待リンクがコピーされました',
    bindRefTitle: '紹介者登録',
    bindRefPlaceholder: '紹介コードを入力',
    bindRefConfirm: '登録確認',
    bindRefSkip: 'スキップ',
    bindRefSuccess: '紹介者登録成功',
    bindRefFailed: '登録失敗、もう一度お試しください',
    bindRefSelf: '自分のアドレスは紹介者として使用できません',
    cycleCountdown: '30日サイクルカウントダウン',
    genesisnode: 'ジェネシスノード',
    genesisnodeEarnings: 'ジェネシスノード収益',
    distance: '距離',
    stillNeed: '必要',
    minorPerformance: 'マイナーゾーン業績',
    reached: '達成済み',
    levelMax: '最高レベル達成',
    cancel: 'キャンセル',
    confirmRedeem: '償還確認',
    genesisWithdrawHint: '利用可能な全収益をウォレットに出金します。',
    insufficientBalance: '残高不足',
    balanceDetail: '取引履歴',
    noRecords: '記録なし',
    loadMore: 'もっと見る',
    typeOrderIncome: '注文収入',
    typeReward: 'ランク報酬',
    typeGenerationReward: '紹介報酬',
    typeWithdraw: '出金',
    typeWithdrawRefund: '出金返金',
    typeReinvest: '再投資',
    typeRedeem: '償還',
  },
  vi: {
    connectWallet: 'Kết nối ví',
    switchWallet: 'Đã kết nối',
    disconnected: 'Chưa kết nối',
    installWallet: 'Vui lòng cài đặt MetaMask hoặc ví Web3 khác',
    connectFirst: 'Vui lòng kết nối ví trước',
    tabHome: 'Trang chủ',
    tabInvest: 'Đầu tư',
    tabWithdraw: 'Rút tiền',
    tabTeam: 'Nhóm',
    walletBalance: 'Số dư ví',
    healthy: 'Tốt',
    ocPrice: 'Giá OC thời gian thực',
    sellTax: 'Thuế bán hiện tại',
    onChainSource: 'Giá on-chain',
    srtDynamic: 'SRT động',
    todayYield: 'Lợi nhuận hôm nay',
    yieldDesc: 'Được xác định bởi pool OC/ALK',
    bonusPool: 'Số dư quỹ thưởng',
    bonusAmount: '231M OC',
    bonusDesc: 'Tự động bổ sung khi dưới ngưỡng',
    enterAmount: 'Nhập số tiền đầu tư',
    min: 'Tối thiểu',
    max: 'Tối đa',
    investDesc: 'Tự động phân chia: 50% mua OC, 50% kết hợp OC/ALK LP khóa.',
    confirmInvest: 'Xác nhận đầu tư',
    myOrders: 'Lệnh của tôi',
    order: 'Lệnh',
    principal: 'Vốn',
    dailyYield: 'Lợi nhuận ngày',
    fullReinvest: 'Tái đầu tư toàn bộ',
    redeemExit: 'Rút & Thoát',
    running: 'Đang chạy',
    expired: 'Hết hạn',
    daysLeft: ' ngày còn lại',
    expiredProcess: 'Hết hạn, xử lý ngay',
    availableBalance: 'Số dư có thể rút',
    notice: 'Số tiền thực nhận = số tiền - 3% phí. Tùy theo xác nhận cuối cùng.',
    confirmInfo: 'Thông tin xác nhận rút tiền',
    applyAmount: 'Số tiền yêu cầu',
    receiveRatio: 'Tỷ lệ nhận',
    estimatedReceipt: 'Dự kiến nhận',
    equivalentOC: 'OC tương đương USDT',
    forceReinvest: 'Tái đầu tư bắt buộc',
    profitTax: 'Thuế lợi nhuận',
    fee: 'Phí',
    receiveAmount: 'Số tiền nhận',
    reinvest100: 'Tái đầu tư 100U',
    reinvest100Hint: 'Sẽ trừ 100 USDT tương đương OC từ số dư để tạo lệnh tái đầu tư 30 ngày.',
    confirm: 'Xác nhận',
    confirmWithdraw: 'Xác nhận rút',
    withdrawSuccess: 'Yêu cầu rút đã được gửi',
    reinvestSuccess: 'Tái đầu tư đã được gửi',
    referralLink: 'Liên kết giới thiệu',
    copyLink: 'Sao chép liên kết',
    directCount: 'Giới thiệu trực tiếp',
    teamCount: 'Quy mô nhóm',
    gen1: 'Thế hệ 1',
    gen1to15: 'Thế hệ 1-15',
    currentLevel: 'Cấp hiện tại',
    levelBonus: 'Thưởng chênh lệch',
    majorZone: 'Vùng chính',
    minorZone: 'Vùng phụ',
    largestBranch: 'Nhánh lớn nhất',
    otherBranches: 'Các nhánh khác',
    teamStructure: 'Cơ cấu nhóm',
    teamDept: 'Bộ phận',
    major: 'Chính',
    minor: 'Phụ',
    rewardsOverview: 'Tổng quan phần thưởng',
    orderReward: 'Thu nhập lệnh',
    levelDiffReward: 'Thưởng chênh lệch cấp',
    managementReward: 'Thưởng quản lý',
    todayReward: 'Hôm nay',
    today: 'Hôm nay',
    linkCopied: 'Đã sao chép liên kết mời',
    bindRefTitle: 'Liên kết người giới thiệu',
    bindRefPlaceholder: 'Nhập mã giới thiệu',
    bindRefConfirm: 'Xác nhận',
    bindRefSkip: 'Bỏ qua',
    bindRefSuccess: 'Đã liên kết người giới thiệu thành công',
    bindRefFailed: 'Liên kết thất bại, vui lòng thử lại',
    bindRefSelf: 'Không thể dùng địa chỉ của chính mình làm người giới thiệu',
    cycleCountdown: 'Đếm Ngược Chu Kỳ 30 Ngày',
    genesisnode: 'Genesis Node',
    genesisnodeEarnings: 'Thu nhập Genesis Node',
    distance: 'Cách',
    stillNeed: 'cần thêm',
    minorPerformance: 'hiệu suất vùng phụ',
    reached: 'Đạt',
    levelMax: 'Đã đạt cấp cao nhất',
    cancel: 'Hủy',
    confirmRedeem: 'Xác nhận chuộc',
    genesisWithdrawHint: 'Rút toàn bộ thu nhập khả dụng về ví của bạn.',
    insufficientBalance: 'Số dư không đủ',
    balanceDetail: 'Lịch sử giao dịch',
    noRecords: 'Không có bản ghi',
    loadMore: 'Tải thêm',
    typeOrderIncome: 'Thu nhập đơn hàng',
    typeReward: 'Thưởng hạng',
    typeGenerationReward: 'Thưởng giới thiệu',
    typeWithdraw: 'Rút tiền',
    typeWithdrawRefund: 'Hoàn tiền rút',
    typeReinvest: 'Tái đầu tư',
    typeRedeem: 'Chuộc',
  },
  id: {
    connectWallet: 'Hubungkan Dompet',
    switchWallet: 'Terhubung',
    disconnected: 'Terputus',
    installWallet: 'Silakan instal MetaMask atau dompet Web3 lainnya',
    connectFirst: 'Silakan hubungkan dompet Anda terlebih dahulu',
    tabHome: 'Dasbor',
    tabInvest: 'Investasi',
    tabWithdraw: 'Penarikan',
    tabTeam: 'Tim',
    walletBalance: 'Saldo Dompet',
    healthy: 'Sehat',
    ocPrice: 'Harga OC Real-time',
    sellTax: 'Pajak Jual Saat Ini',
    onChainSource: 'Harga On-chain',
    srtDynamic: 'SRT Dinamis',
    todayYield: 'Imbal Hasil Hari Ini',
    yieldDesc: 'Ditentukan oleh pool OC/ALK',
    bonusPool: 'Saldo Pool Bonus',
    bonusAmount: '231M OC',
    bonusDesc: 'Isi ulang otomatis di bawah ambang batas',
    enterAmount: 'Masukkan Jumlah Investasi',
    min: 'Min',
    max: 'Maks',
    investDesc: 'Pembagian otomatis: 50% beli OC, 50% gabungkan OC/ALK LP kunci.',
    confirmInvest: 'Konfirmasi Investasi',
    myOrders: 'Pesanan Saya',
    order: 'Pesanan',
    principal: 'Modal',
    dailyYield: 'Imbal Hasil Harian',
    fullReinvest: 'Reinvestasi Penuh',
    redeemExit: 'Tebus & Keluar',
    running: 'Berjalan',
    expired: 'Kedaluwarsa',
    daysLeft: ' hari tersisa',
    expiredProcess: 'Kedaluwarsa, proses sekarang',
    availableBalance: 'Saldo Dapat Ditarik',
    notice: 'Penerimaan aktual = jumlah - 3% biaya. Tergantung konfirmasi akhir.',
    confirmInfo: 'Info Konfirmasi Penarikan',
    applyAmount: 'Jumlah Permohonan',
    receiveRatio: 'Rasio Penerimaan',
    estimatedReceipt: 'Perkiraan Penerimaan',
    equivalentOC: 'OC setara USDT',
    forceReinvest: 'Reinvestasi Paksa',
    profitTax: 'Pajak Keuntungan',
    fee: 'Biaya',
    receiveAmount: 'Jumlah Diterima',
    reinvest100: 'Reinvestasi 100U',
    reinvest100Hint: 'Akan mengurangi 100 USDT setara OC dari saldo untuk membuat pesanan reinvestasi 30 hari.',
    confirm: 'Konfirmasi',
    confirmWithdraw: 'Konfirmasi Penarikan',
    withdrawSuccess: 'Penarikan telah diajukan',
    reinvestSuccess: 'Reinvestasi telah diajukan',
    referralLink: 'Tautan Referral',
    copyLink: 'Salin Tautan',
    directCount: 'Referral Langsung',
    teamCount: 'Ukuran Tim',
    gen1: 'Gen 1',
    gen1to15: 'Gen 1-15',
    currentLevel: 'Level Saat Ini',
    levelBonus: 'Bonus Selisih Level',
    majorZone: 'Zona Utama',
    minorZone: 'Zona Minor',
    largestBranch: 'Cabang Terbesar',
    otherBranches: 'Cabang Lainnya',
    teamStructure: 'Struktur Tim',
    teamDept: 'Dept',
    major: 'Utama',
    minor: 'Minor',
    rewardsOverview: 'Ikhtisar Hadiah',
    orderReward: 'Imbal Hasil Pesanan',
    levelDiffReward: 'Bonus Selisih Level',
    managementReward: 'Bonus Manajemen',
    todayReward: 'Hari ini',
    today: 'Hari ini',
    linkCopied: 'Tautan undangan disalin',
    bindRefTitle: 'Ikat Referral',
    bindRefPlaceholder: 'Masukkan kode referral',
    bindRefConfirm: 'Konfirmasi',
    bindRefSkip: 'Lewati',
    bindRefSuccess: 'Referral berhasil diikat',
    bindRefFailed: 'Pengikatan gagal, coba lagi',
    bindRefSelf: 'Tidak dapat menggunakan alamat sendiri sebagai referral',
    cycleCountdown: 'Hitung Mundur Siklus 30 Hari',
    genesisnode: 'Genesis Node',
    genesisnodeEarnings: 'Penghasilan Genesis Node',
    distance: 'Jarak ke',
    stillNeed: 'masih butuh',
    minorPerformance: 'performa zona minor',
    reached: 'Tercapai',
    levelMax: 'Level maksimal tercapai',
    cancel: 'Batal',
    confirmRedeem: 'Konfirmasi Tebus',
    genesisWithdrawHint: 'Tarik semua penghasilan yang tersedia ke dompet Anda.',
    insufficientBalance: 'Saldo tidak mencukupi',
    balanceDetail: 'Riwayat Transaksi',
    noRecords: 'Tidak ada catatan',
    loadMore: 'Muat lebih banyak',
    typeOrderIncome: 'Pendapatan Pesanan',
    typeReward: 'Hadiah Peringkat',
    typeGenerationReward: 'Hadiah Referral',
    typeWithdraw: 'Penarikan',
    typeWithdrawRefund: 'Pengembalian Penarikan',
    typeReinvest: 'Reinvestasi',
    typeRedeem: 'Penebusan',
  },
}

export function getMessages(lang) {
  return messages[lang] || messages.en
}

export default messages
